import React, { Component } from "react";
import Utils from "../../utils";
import contractAddress from "../Contract";
import cons from "../../cons.js";

export default class WaterMaker extends Component {
  constructor(props) {
    super(props);

    this.state = {

      min: 100,
      deposito: "Loading...",
      balance: "Loading...",
      accountAddress: "Loading...",
      porcentaje: "Loading...",
      dias: "Loading...",
      partner: "Loading...",
      balanceTRX: "Loading...",
      balanceUSDT: "Loading...",
      maxButton:"Loading...",
      precioH2O: 0

    };

    this.deposit = this.deposit.bind(this);
    this.estado = this.estado.bind(this);
    this.getMax = this.getMax.bind(this);

    this.rateH2O = this.rateH2O.bind(this);
  }

  async componentDidMount() {
    await Utils.setContract(window.tronWeb, contractAddress);
    await this.estado();
    setInterval(() => this.estado(),2*5000);
  };

  async rateH2O(){
    var proxyUrl = cons.proxy;
    var apiUrl = cons.PRE;
    const response = await fetch(proxyUrl+apiUrl)
    .catch(error =>{console.error(error)})
    const json = await response.json();

    return json.Data.precio;

  };

  async estado(){

    var accountAddress =  await window.tronWeb.trx.getAccount();
    accountAddress = window.tronWeb.address.fromHex(accountAddress.address);

    var inicio = accountAddress.substr(0,4);
    var fin = accountAddress.substr(-4);

    var texto = inicio+"..."+fin;

   // document.getElementById("contract").innerHTML = '<a href="https://tronscan.org/#/contract/'+contractAddress+'/code">WaterMaker Contract</a>';

     //document.getElementById("login").innerHTML = '<a href="https://tronscan.io/#/address/'+accountAddress+'" class="logibtn gradient-btn">'+texto+'</a>';
    document.getElementById("login").href = `https://tronscan.io/#/address/${accountAddress}`;
    document.getElementById("login-my-wallet").innerHTML = texto;

    var contractH2O = await window.tronWeb.contract().at(cons.USDT);

    var aprovado = await contractH2O.allowance(accountAddress,contractAddress).call();
    aprovado = parseInt(aprovado._hex);

    if (aprovado > 0) {
      aprovado = "Deposit";
    }else{
      document.getElementById("amount").value = "";
      aprovado = "Register / Deposit";
    }

    var decimales = await contractH2O.decimals().call();

    var balance = await contractH2O.balanceOf(accountAddress).call();
    balance = parseInt(balance._hex)/10**decimales;

    var MIN_DEPOSIT = await Utils.contract.MIN_DEPOSIT().call();
    MIN_DEPOSIT = parseInt(MIN_DEPOSIT._hex)/10**decimales;

    var MAX_DEPOSIT = await Utils.contract.MAX_DEPOSIT().call();
    MAX_DEPOSIT = parseInt(MAX_DEPOSIT._hex)/10**decimales;

    var partner = cons.WS;

    var inversors = await Utils.contract.investors(accountAddress).call();

    if ( inversors.registered ) {
      partner = window.tronWeb.address.fromHex(inversors.sponsor);
    }else{

      var loc = document.location.href;
      if(loc.indexOf('?')>0){
          var getString = loc.split('?')[1];
          var GET = getString.split('&');
          var get = {};
          for(var i = 0, l = GET.length; i < l; i++){
              var tmp = GET[i].split('=');
              get[tmp[0]] = unescape(decodeURI(tmp[1]));
          }

          if (get['ref']) {
            tmp = get['ref'].split('#');

            inversors = await Utils.contract.investors(tmp[0]).call();

            if ( inversors.registered ) {
              partner = tmp[0];
            }
          }
      }

    }

    if(partner === "TNcrrffQep5zopLojKHXwJ7aN4iE3rEmy2"){
      partner = "---------------------------------";
    }

    
    
     var dias = await Utils.contract.tiempo().call();

    var velocidad = await Utils.contract.velocidad().call();

    dias = (parseInt(dias)/86400)*velocidad;
    
    var porcentaje = await Utils.contract.porcent().call();

    porcentaje = parseInt(porcentaje);

    var balanceh2o = await contractH2O.balanceOf(accountAddress).call();
    balanceh2o = parseInt(balanceh2o._hex);

    var balanceTRX = await window.tronWeb.trx.getBalance();
    balanceTRX = balanceTRX/10**6;

    var contractUSDT = await window.tronWeb.contract().at("TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t");

    var balanceUSDT = await contractUSDT.balanceOf(accountAddress).call();

    balanceUSDT = parseInt(balanceUSDT)/10**6;

    var precioH2O = await this.rateH2O();

    this.setState({
      deposito: aprovado,
      balance: balance,
      decimales: decimales,
      accountAddress: accountAddress,
      porcentaje: porcentaje,
      dias: dias,
      min: MIN_DEPOSIT,
      max: MAX_DEPOSIT,
      partner: partner,
      balanceh2o: balanceh2o,
      balanceTRX: balanceTRX,
      balanceUSDT: balanceUSDT,
      precioH2O: precioH2O,
      maxAlcanzado: parseInt(inversors.invested)/10**decimales <= MAX_DEPOSIT,
      maxButton:"Max"
    });
  }


  async deposit() {

    const {  deposito, decimales, balanceH2O, balanceTRX, maxAlcanzado } = this.state;

    var { min, max } = this.state

    min = min*10**decimales;
    max = max*10**decimales;

    var amount = document.getElementById("amount").value;

    amount = parseFloat(amount);
    amount = parseInt(amount*10**decimales);

    //console.log(amount);

    //console.log(isNaN(amount));

    var accountAddress =  await window.tronWeb.trx.getAccount();
  
    accountAddress = window.tronWeb.address.fromHex(accountAddress.address);

    var tronUSDT = await window.tronWeb;
    var contractUSDT = await tronUSDT.contract().at(cons.USDT);

    if (deposito === "DEPOSIT" && balanceTRX >= 10){
      document.getElementById("amount").value = "";
      await contractUSDT.approve(contractAddress, "115792089237316195423570985008687907853269984665640564039457584007913129639935").send();
    }else{
      var aprovado = await contractUSDT.allowance(accountAddress, contractAddress).call();
      aprovado = parseInt(aprovado._hex);
    }

    if ( aprovado >= amount && 
      aprovado > 0 && 
      balanceH2O >= amount && 
      amount >= min && 
      amount <= max && 
      balanceTRX >= 50 && 
      deposito !== "DEPOSIT" &&
      maxAlcanzado
      ){


        
        var loc = document.location.href;
        var sponsor = cons.WS;

        var investors = await Utils.contract.investors(accountAddress).call();

        if (investors.registered) {

          sponsor = investors.sponsor;

        }else{

          if(loc.indexOf('?')>0){
            
            var getString = loc.split('?')[1];
            var GET = getString.split('&');
            var get = {};
            for(var i = 0, l = GET.length; i < l; i++){
                var tmp = GET[i].split('=');
                get[tmp[0]] = unescape(decodeURI(tmp[1]));
            }

            if (get['ref']) {
              tmp = get['ref'].split('#');

              var inversors = await Utils.contract.investors(tmp[0]).call();

              console.log(inversors);

              if ( inversors.registered ) {
                sponsor = tmp[0];
              }
            }

          }
          
        }

    
        if ( amount >= min ){

          await Utils.contract.deposit(amount, sponsor).send();

          document.getElementById("amount").value = "";

          window.alert("Congratulations! Your deposit is successful");

          document.getElementById("services").scrollIntoView({block: "end", behavior: "smooth"});;

        }


    }else{

      
      if ( amount < min ) {
        document.getElementById("amount").value = min/10**decimales;
        window.alert("Please place an amount greater than "+(min/10**decimales)+" H2O");
      }

      if ( amount > max ) {
        document.getElementById("amount").value = "";
        window.alert("Please place an amount less than "+(max/10**decimales)+" H2O");
      }

      if ( balanceH2O < amount ) {
        document.getElementById("amount").value = "";
        window.alert("You do not have enough H2O. Buy more H2O");
      }

      if (!maxAlcanzado) {
        document.getElementById("amount").value = "";
        window.alert("Maximum deposit limit reached");
      }

      if (balanceTRX < 10) {
        await window.alert("Your account must have at least 10 TRX to execute the transaction correctly");
  
      }

      
    }


  };

  getMax() {
    document.getElementById("amount").value = this.state.balance;
  }

  render() {

    var min = this.state.min;

    min = "Minimum "+min+" H2O";



    return (
   
      
        <div className="flex-1 justify-content-center order-12" >
       
          <div className="form-group">
            <p>&nbsp; </p>
        <h3 className="darkblue" id="contract" align="center">WaterMaker Contract</h3>
         <p>&nbsp; </p>
        
<h4 className="blue justify">
<i className="bi bi-check"></i>&nbsp; {this.state.porcentaje}% &nbsp;  TOTAL ROI/APR<br/>
<i className="bi bi-check"></i>&nbsp; IN {this.state.dias}  DAYS<br/>
<i className="bi bi-check"></i>&nbsp; {((((this.state.porcentaje)))/(this.state.dias)).toFixed(2)}% &nbsp; DAILY RETURNS<br/>
<i className="bi bi-check"></i>&nbsp; {(this.state.porcentaje)/12}%  &nbsp; MONTHLY RETURNS<br/>

<i className="bi bi-check"></i>&nbsp; 10% REFFERAL BONUS IN 3 LEVELS <br/>
<i className="bi bi-check"></i>&nbsp; 100 H2O MINIMUM DEPOSIT <br/>
<i className="bi bi-check"></i>&nbsp; WITHDRAW ANYTIME <br/>
<i className="bi bi-check"></i>&nbsp; NO WITHDRAW PENALTIES<br/>

</h4>
 <p>&nbsp; </p>
 
          <h3 className="darkblue" align="center">Wallet Balance</h3>
          <p  >
            <strong>{this.state.accountAddress}</strong><br />
          </p>
          <p >
        
           <span className="blue"> H2O:</span> <strong>{this.state.balance.toLocaleString("en-US")}</strong> (${(this.state.balance*this.state.precioH2O).toLocaleString("en-US")})<br />
            <span className="blue"> TRX:</span> <strong>{(this.state.balanceTRX*1).toLocaleString("en-US")}</strong><br />
            <span className="blue"> USDT:</span> <strong>{(this.state.balanceUSDT*1).toLocaleString("en-US")}</strong><br />
          </p>

          <div className="input-group mb-3">
            <input id="amount" type="number" className="form-control mb-20 text-center" placeholder={min}></input>
            <div className="input-group-append">
              <button className="btn btn-outline-secondary" type="button" onClick={this.getMax}>{this.state.maxButton}</button>
            </div>
          </div>
         
             <button className="btn btn-success" onClick={() => this.deposit()}>{this.state.deposito}</button>
              <br/>
            <p className="card-text"><sup className="red">*</sup> We recommend 30 TRX available to complete the transaction!</p>
            <br/>
            <p className="card-text"><strong>Referrer:</strong><br />
            <span className="blue">{this.state.partner}</span></p>

           
            
          </div>
   
      </div>
 


    );
  }
}
